import { configure, getSdks } from '@monterosa/sdk-core'
import {
  getProject,
  getEvents,
  getEvent,
  getElements,
  onEventAdded,
} from '@monterosa/sdk-interact-kit'
import { getStorage } from '../../utils/votingStorage.js'
import { createVotingInitializer } from './initializeVoting'

export const init = createVotingInitializer({
  configure,
  getSdks,
  getProject,
  getEvents,
  getEvent,
  getElements,
  onEventAdded,
  getStorage,
})
